export const resources = {
    func: {
        eq: {
            label: '=',
            hint: 'Funkce vrátí hodnotu PRAVDA, pokud hodnota parametru <code>hodnota1</code>  je rovna hodnotě parametru <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První testovaná hodnota.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Druhá porovnávaná hodnota.'
                }
            }
        },
        ne: {
            label: '<>',
            hint: 'Funkce porovná, zda hodnota1 není rovna hodnota2.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První porovnávaná hodnota.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Druhá porovnávaná hodnota.'
                }
            }
        },
        gt: {
            label: '>',
            hint: 'Funkce vrátí hodnotu PRAVDA, pokud hodnota parametru <code>hodnota1</code>  je větší než hodnota parametru <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První porovnávaná hodnota.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Druhá porovnávaná hodnota.'
                }
            }
        },
        ge: {
            label: '>=',
            hint: 'Funkce vrátí hodnotu PRAVDA, pokud hodnota parametru <code>hodnota1</code>  je větší než nebo rovna hodnotě parametru <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První porovnávaná hodnota.'
                },
                value2: {
                    label: 'value2',
                    hint: 'Druhá porovnávaná hodnota.'
                }
            }
        },
        lt: {
            label: '<',
            hint: 'Funkce vrátí hodnotu PRAVDA, pokud hodnota parametru <code>hodnota1</code>  je menší než hodnota parametru <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První porovnávaná hodnota.'
                },
                value2: {
                    label: 'hodnota',
                    hint: 'Druhá porovnávaná hodnota.'
                }
            }
        },
        le: {
            label: '<=',
            hint: 'Funkce vrátí hodnotu PRAVDA, pokud hodnota parametru <code>hodnota1</code>  je menší než nebo rovna hodnotě parametru <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První porovnávaná hodnota.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Druhá porovnávaná hodnota.'
                }
            }
        },
        isNull: {
            label: 'Je prázdná',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud <code>hodnota</code> je prázdná (NULL).',
            param: {
                value: {
                    label: 'hodnota',
                    hint: 'Testovaná hodnota.'
                }
            }
        },
        isNotNull: {
            label: 'Není prázdná',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud <code>hodnota</code> není prázdná (NULL).',
            param: {
                value: {
                    label: 'hodnota',
                    hint: 'Testovaná hodnota.'
                }
            }
        },
        between: {
            label: 'Je mezi',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud <code>hodnota</code> je větší než nebo rovna <code>min</code> a zároveň je menší než nebo rovna <code>max</code>.',
            param: {
                value: {
                    label: 'hodnota',
                    hint: 'Testovaná hodnota.'
                },
                min: {
                    label: 'min',
                    hint: 'Dolní hranice intervalu.'
                },
                max: {
                    label: 'max',
                    hint: 'Horní hranice intervalu.'
                }
            }
        },
        contains: {
            label: 'Obsahuje',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud text <code>kde</code> obsahuje text <code>co</code>.',
            param: {
                where: {
                    label: 'kde',
                    hint: 'Prohledávaný text.'
                },
                what: {
                    label: 'co',
                    hint: 'Hledaný text.'
                }
            }
        },
        startsWith: {
            label: 'Má na začátku',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud text <code>kde</code> má na začátku text <code>co</code>.',
            param: {
                where: {
                    label: 'kde',
                    hint: 'Prohledávaný text.'
                },
                what: {
                    label: 'co',
                    hint: 'Hledaný text.'
                }
            }
        },
        endsWith: {
            label: 'Má na konci',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud text <code>kde</code> má na konci text <code>co</code>.',
            param: {
                where: {
                    label: 'kde',
                    hint: 'Prohledávaný text.'
                },
                what: {
                    label: 'co',
                    hint: 'Hledaný text.'
                }
            }
        },
        notContains: {
            label: 'Neobsahuje',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud text <code>kde</code> neobsahuje text <code>co</code>.',
            param: {
                where: {
                    label: 'kde',
                    hint: 'Prohledávaný text.'
                },
                what: {
                    label: 'co',
                    hint: 'Hledaný text.'
                }
            }
        },
        notStartsWith: {
            label: 'Nemá na začátku',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud text <code>kde</code> nemá na začátku text <code>co</code>.',
            param: {
                where: {
                    label: 'kde',
                    hint: 'Prohledávaný text.'
                },
                what: {
                    label: 'co',
                    hint: 'Hledaný text.'
                }
            }
        },
        notEndsWith: {
            label: 'Nemá na konci',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud text <code>kde</code> nemá na konci text <code>co</code>.',
            param: {
                where: {
                    label: 'kde',
                    hint: 'Prohledávaný text.'
                },
                what: {
                    label: 'co',
                    hint: 'Hledaný text.'
                }
            }
        },
        add: {
            label: '+',
            hint: 'Funkce vrátí součet hodnot <code>hodnota1</code> a <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První sčítaná hodnota.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Druhá sčítaná hodnota.'
                }
            }
        },
        sub: {
            label: '-',
            hint: 'Funkce vrátí rozdíl hodnot <code>hodnota1</code> a <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'Menšenec.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Menšitel.'
                }
            }
        },
        mul: {
            label: '*',
            hint: 'Funkce vrátí součin hodnot <code>hodnota1</code> a <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'První násobená hodnota.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Druhá násobená hodnota.'
                }
            }
        },
        div: {
            label: '/',
            hint: 'Funkce vrátí podíl hodnot <code>hodnota1</code> a <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'Dělenec.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Dělitel.'
                }
            }
        },
        mod: {
            label: '%',
            hint: 'Funkce vrátí zbytek po dělení hodnoty <code>hodnota1</code> hodnotou <code>hodnota2</code>.',
            param: {
                value1: {
                    label: 'hodnota1',
                    hint: 'Dělenec.'
                },
                value2: {
                    label: 'hodnota2',
                    hint: 'Dělitel.'
                }
            }
        },
        concat: {
            label: 'Spojit',
            hint: 'Funkce vrátí text vzniklý spojením <code>text1</code> a <code>text2</code>.',
            param: {
                text1: {
                    label: 'text1',
                    hint: 'První spojovaný text.'
                },
                text2: {
                    label: 'text2',
                    hint: 'Druhý spojovaný text.'
                }
            }
        },
        substring: {
            label: 'Část',
            hint: 'Funkce vrátí část textového řetězce <code>text</code> od pozice <code>start</code> v délce <code>délka</code> znaků.',
            param: {
                text: {
                    label: 'text',
                    hint: 'Zdrojový text.'
                },
                start: {
                    label: 'start',
                    hint: 'Pozice prvního vráceného znaku.'
                },
                length: {
                    label: 'délka',
                    hint: 'Počet vrácených znaků.'
                }
            }
        },
        left: {
            label: 'Zleva',
            hint: 'Funkce vrátí část textu <code>text</code> v délce <code>délka</code> znaků od začátku textu.',
            param: {
                text: {
                    label: 'text',
                    hint: 'Zdrojový text.'
                },
                length: {
                    label: 'délka',
                    hint: 'Počet vrácených znaků.'
                }
            }
        },
        right: {
            label: 'Zprava',
            hint: 'Funkce vrátí textový řetězec v délce <code>délka</code> znaků od konce textu <code>text</code>.',
            param: {
                text: {
                    label: 'text',
                    hint: 'Zdrojový text.'
                },
                length: {
                    label: 'délka',
                    hint: 'Počet vrácených znaků.'
                }
            }
        },
        toLower: {
            label: 'Na malá písmena',
            hint: 'Funkce vrátí textový řetězec <code>text</code> převedený na malá písmena.',
            param: {
                text: {
                    label: 'text',
                    hint: 'Zdrojový text.'
                }
            }
        },
        toUpper: {
            label: 'Na velká písmena',
            hint: 'Funkce vrátí textový řetězec <code>text</code> převedený na velká písmena.',
            param: {
                text: {
                    label: 'text',
                    hint: 'Zdrojový text.'
                }
            }
        },
        round: {
            label: 'Zaokrouhlit',
            hint: 'Funkce zaokrouhlí desetinné číslo <code>value</code> na nejbližší číselnou hodnotu bez desetinné složky. Střed mezi dvěma celými čísly je zaokrouhlen od nuly, tj. 0,5 je zaokrouhleno na 1 a -0,5 je zaokrouhleno na -1.',
            param: {
                value: {
                    label: 'hodnota',
                    hint: 'Zaokrouhlovaná hodnota.'
                }
            }
        },
        ceiling: {
            label: 'Zaokrouhlit nahoru',
            hint: 'Funkce zaokrouhlí desetinné číslo <code>value</code> na nejbližší číselnou hodnotu bez desetinné složky. Střed mezi dvěma celými čísly je zaokrouhlen od nuly, tj. 0,5 je zaokrouhleno na 1 a -0,5 je zaokrouhleno na -1.',
            param: {
                value: {
                    label: 'hodnota',
                    hint: 'Zaokrouhlovaná hodnota.'
                }
            }
        },
        floor: {
            label: 'Zaokrouhlit dolů',
            hint: 'Funkce zaokrouhlí desetinné číslo <code>value</code> na nejbližší číselnou hodnotu bez desetinné složky. Střed mezi dvěma celými čísly je zaokrouhlen od nuly, tj. 0,5 je zaokrouhleno na 1 a -0,5 je zaokrouhleno na -1.',
            param: {
                value: {
                    label: 'hodnota',
                    hint: 'Zaokrouhlovaná hodnota.'
                }
            }
        },
        not: {
            label: 'NEPLATÍ',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud je výraz <code>expr</code> roven hodnotě NEPRAVDA. Jinak vrací hodnotu NEPRAVDA.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'Zdrojový výraz.'
                }
            }
        },
        and: {
            label: 'A PLATÍ',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud jsou oba výrazy <code>expr1</code> a <code>expr2</code> rovny hodnotě PRAVDA. Jinak vrací hodnotu NEPRAVDA.',
            param: {
                expr1: {
                    label: 'expr1',
                    hint: 'První zdrojový výraz.'
                },
                expr2: {
                    label: 'expr2',
                    hint: 'Druhý zdrojový výraz.'
                }
            }
        },
        or: {
            label: 'NEBO PLATÍ',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud je alespoň jeden z výrazů <code>expr1</code> a <code>expr2</code> roven hodnotě PRAVDA. Jinak vrací hodnotu NEPRAVDA.',
            param: {
                expr1: {
                    label: 'expr1',
                    hint: 'První zdrojový výraz.'
                },
                expr2: {
                    label: 'expr2',
                    hint: 'Druhý zdrojový výraz.'
                }
            }
        },
        in: {
            label: 'Je jedna z hodnot',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud výraz <code>expr1</code> je roven některé z hodot <code>hodnota1</code> a <code>hodnota2</code>. Jinak vrací hodnotu NEPRAVDA.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'Zdrojový výraz.'
                },
                value1: {
                    label: 'value1',
                    hint: 'První přípustná hodnota.'
                },
                value2: {
                    label: 'value2',
                    hint: 'Druhá přípustná hodnota.'
                }
            }
        },
        notIn: {
            label: 'Není jedna z hodnot',
            hint: 'Funkce vrátí hodnotu PRAVDA pokud výraz <code>expr1</code> není roven některé z hodot <code>hodnota1</code> a <code>hodnota2</code>. Jinak vrací hodnotu NEPRAVDA.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'Zdrojový výraz.'
                },
                value1: {
                    label: 'value1',
                    hint: 'První nepřípustná hodnota.'
                },
                value2: {
                    label: 'value2',
                    hint: 'Druhá nepřípustná hodnota.'
                }
            }
        },
        if: {
            label: 'Když',
            hint: 'Funkce vrátí hodnotu <code>hodnota1</code> pokud výraz <code>expr</code> je roven hodnotě PRAVDA. Jinak vrací hodnotu <code>hodnota2</code>.',
            param: {
                expr: {
                    label: 'expr',
                    hint: 'Zdrojový výraz.'
                },
                value1: {
                    label: 'value1',
                    hint: 'Hodnota vrácená v případě, že <code>výraz</code> je roven hodnotě PRAVDA.'
                },
                value2: {
                    label: 'value2',
                    hint: 'Hodnota vrácená v případě, že <code>výraz</code> neí roven hodnotě PRAVDA.'
                }
            }
        }
    }
};
